var cf,
confirmation = {
	settings: {
		
	},
	init: function() {
		cf = this.settings;
		this.bindUIActions();
		console.log('confirmation loaded!');
	},
	bindUIActions: function() {
			// Create array to hold the locations, and a variable to hold the location value
			// On click of "submit": 
			//  - add new location to array, 
			//  - cycle through array, and return the location variable
			//  - populate the "hidden" input with the location variable


			// Service Request Form
			var button = $('input#gform_submit_button_3'); 
			var hidden = $('input#input_3_28');

			// Live Test Form
			// var button = $('input#gform_submit_button_6'); 
			// var hidden = $('input#input_6_2');

			// Local Test Form
			// var button = $('input#gform_submit_button_5'); //local test form
			// var hidden = $('input#input_5_6'); //local test form
			var locations = [];
			var url = '';

			// on submit, prevent default, run array logic, populate hidden field, formID.submit()
			button
				.on('click', function (evt) {
					evt.preventDefault();
					var location_values = $('table.gfcs-value tr:nth-of-type(2) td:nth-of-type(2) span');
					locations = [];
					location_values.each(function() {
						locations.push($(this).text());
					})
					if ($.inArray('Denver', locations) > -1 && $.inArray('Lexington', locations) < 0) {
						url = 'Denver';
					}
					if ($.inArray('Denver', locations) < 0 && $.inArray('Lexington', locations) > -1) {
						url = 'Lexington';
					}
					if ($.inArray('Denver', locations) > -1 && $.inArray('Lexington', locations) > -1) {
						url = 'Both';
					}
					hidden.val(url);
					// console.log(hidden.val());

					// $('form#gform_6').submit();
					$('form#gform_3').submit();
					// $('form#gform_5').submit(); //local test form

				});

	}
};
